import { restart } from './restart';
import { update } from './update';

export const actions = {
  restart,
  update,
};
